module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"appName":" Verification System","help":"Help","privacyPolicy":"Privacy Policy"},"ja":{"appName":"手続きシステム","help":"ヘルプ","privacyPolicy":"Privacy Policy"}}')
  delete Component.options._Ctor
}
